
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.75 9.75h6.5V13a3.25 3.25 0 01-6.5 0V9.75z","stroke":"#989AB2","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M10 9V7M14 9V7","stroke":"#989AB2","stroke-width":"1.5","stroke-linecap":"round"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"9.25","stroke":"#989AB2","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M12 16.5v4","stroke":"#989AB2","stroke-width":"1.5"}})])
          )
        }
      }
    